<template>
	<div class="bg-white container-fluid px-5 pb-5">
		<div class="row">
			<div class="col-12">
				<div>
                    <table class="w-100" :style="{visibility: visibility}">
                        <thead>
							<tr>
								<td>
									<div class="row">
										<div class="col-12">
											<div class="position-relative mb-3">
												<div v-if="account_logo" class="logo-container">
													<img :src="account_logo" style="height: 100px; position: absolute; top: 8px;">
												</div>
												<div class="logo-instant-container">
													<img :src="logo_instant" class="w-100" style="height: 44px">
												</div>
											</div>
										</div>
									</div>
								</td>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td class="position-relative">
									<table class="w-100 mb-5 main-content">
										<thead>
											<tr>
												<td>
													<div class="form-row mt-3 flex-nowrap text-dark align-items-start header-container" v-if="patient">
														<div class="col-auto mt-2">
															<div 
																class="shadow" 
																style="width: 165px; height: 155px; border: 1px solid #ccc; border-radius: .5rem;"
															>
																<img 
																	:src="patient_avatar" 
																	style="width: 100%; height: 100%; object-fit: cover; border-radius: .5rem;"
																>
															</div>
														</div>
														<div class="col ml-4 h-100 d-flex flex-column justify-content-between">
															<div class="row">
																<div class="col-12 px-0">
																	<span class="spotlight"><b> {{ patient.nome_paciente.toUpperCase() }} </b></span>
																</div>
															</div>
															<div class="row">
																<div class="col-auto px-0">
																	RG: <span :class="patient.rg ? 'font-weight-bold' : 'unknown'">{{ patient_rg }}</span>
																</div>
																<div class="col-auto px-0">
																	CPF: <span :class="patient.cpf ? 'font-weight-bold' : 'unknown'">{{ patient.cpf ? ParseCPF(patient.cpf).toUpperCase() : 'DESCONHECIDO' }}</span>
																</div>
																<div class="col-auto px-0">
																	CNS: <span :class="patient.sus ? 'font-weight-bold' : 'unknown'">{{ patient.sus ? patient.sus.toUpperCase() : 'DESCONHECIDO' }}</span>
																</div>
																<div class="col-auto px-0">
																	RH: <span :class="patient.rh ? 'font-weight-bold' : 'unknown'">{{ patient.rh ? patient.rh.toUpperCase() : 'DESCONHECIDO' }}</span>
																</div>
															</div>
															<div class="row">
																<div class="col-auto px-0">
																	DATA DE NASCIMENTO: <span :class="patient_birthdate ? 'font-weight-bold' : 'unknown'">{{ patient_birthdate }}</span>
																	<span v-if="patient.data_nascimento" :class="patient_age ? 'font-weight-bold' : 'unknown'"> ({{ patient_age }})</span>
																</div>
																<div class="col-auto px-0">
																	SEXO: <span :class="patient.sexo ? 'font-weight-bold' : 'unknown'">{{ patient.sexo ? (patient.sexo === 'm' ? 'MASCULINO' : 'FEMININO') : 'DESCONHECIDO' }}</span>
																</div>
																<div class="col-auto px-0">
																	TELEFONE: <b> {{ patient_telefone }} </b>
																</div>
															</div>
															<div class="row">
																<div v-if="patient.desconhecido" class="col-auto px-0">
																	<b class="text-danger">! DADOS PESSOAIS E DOCUMENTOS DO PACIENTE NÃO VALIDADOS !</b>
																</div> 
															</div>
														</div>
													</div>
													<div class="row">
														<div class="col-12">
															<hr style="border-top: 2px solid #333;" />
														</div>
													</div>
												</td>
											</tr>
										</thead>
										<tbody>
											<tr>
                                                <td>
                                                    <div class="row justify-content-center mt-5">
                                                        <div class="col-auto text-center">
                                                            <qrcode-vue v-if="patientPortalUrl" :text="patientPortalUrl" :size="200" />
                                                            <div class="mt-3" v-if="patientPortalUrl">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row justify-content-center">
                                                        <small>{{ patientPortalUrl }}</small>
                                                    </div>
                                                </td>
                                            </tr>
										</tbody>
									</table>
								</td>
							</tr>
						</tbody>
						<tfoot>
							<tr>
								<td>
									<footer>
										<div class="row position-relative">
											<div class="col-12" v-if="instance">
												<p class="text-center text-dark m-0">
													{{ instance.config.rodape_sup}}
												</p>
											</div>
											<div class="col-12" v-if="instance">
												<p class="text-center text-dark m-0">
													{{instance.config.rodape_inf}}
												</p>
											</div>
										</div>
									</footer>
								</td>
							</tr>
						</tfoot>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import QrcodeVue from 'vue-qrcode-component'
const moment = require('moment')
import { mapGetters } from 'vuex'

export default {
    name: 'PrintPatientQRCode',
    components: { QrcodeVue },
    data() {
        return {
            patient: null,
            default_avatar: window.defaultAvatar,
            logo_instant: require('../../assets/img/header-impressao.png'),
			border_patient:	require('../../assets/img/border-paciente.jpg'),
            visibility: 'hidden',
        }
    },
    watch: {
        'patient.avatar': {
            handler(val) {
                if (val) {
                    this.exihibit_avatar = val || ''
                }
            },
            immediate: true,
        },
    },
    computed: {
        ...mapGetters('auth', ['requester_selected_id', 'requesters']),
        instance() {
            if (!this.patient || !this.patient.account_id) return null
            
            return this.requesters.find(r => parseInt(r.account_requester_id) === parseInt(this.patient.account_id))?.instance
        },
        account_logo() {
            return this.instance?.config?.logo_url
        },
        patient_avatar() {
            return this.patient && this.patient.avatar ? this.patient.avatar : this.default_avatar
        },
        patient_rg() {
            if (!this.patient) return 'DESCONHECIDO'

            const rg = this.patient.rg
                ? this.patient.rg.toUpperCase()
                : ''

            const uf =
                this.patient.rg_uf &&
                this.patient.rg_uf !== 'DESCONHECIDO'
                    ? this.patient.rg_uf.toUpperCase()
                    : ''

            if (!rg) return 'DESCONHECIDO'

            return uf ? `${rg}${uf}` : rg
        },
        patient_birthdate() {
            let birthdate = 'DESCONHECIDO'

            if (!this.patient.data_nascimento) return birthdate

            birthdate = moment(this.patient.data_nascimento).format(
                'DD/MM/YYYY'
            )

            return birthdate
        },
        patient_age() {
            if (this.patient && this.patient.data_nascimento) {
                const dob = moment(
                    this.patient.data_nascimento,
                    'YYYY-MM-DD'
                )
                const today = moment()

                const years = today.diff(dob, 'year')
                dob.add(years, 'years')

                const months = today.diff(dob, 'months')
                dob.add(months, 'months')

                const days = today.diff(dob, 'days')

                let result = ''

                if (years > 0) {
                    result = `${years} ANO${years > 1 ? 'S' : ''}`
                } else if (years === 0 && months > 0) {
                    result = `${months} MES${
                        months > 1 ? 'ES' : ''
                    } e ${days} DIA${days > 1 ? 'S' : ''}`
                } else if (months === 0 && days > 0) {
                    result = `${days} DIA${days > 1 ? 'S' : ''}`
                } else {
                    result = '0 DIAS'
                }

                return result
            } else {
                return 'DESCONHECIDO'
            }
        },
        patient_telefone() {
            if (!this.patient || !this.patient.telefone) return 'DESCONHECIDO'

            let telArr = []

            try {
                telArr = JSON.parse(this.patient.telefone.replace(/\\/g, ''))
            } catch (e) {
                return 'DESCONHECIDO'
            }

            const telefone_1 = telArr.find(t => t)

            return telefone_1 || 'DESCONHECIDO'
        },
        patientPortalUrl() {
            const base = (process && process.env && process.env.VUE_APP_PORTAL_URL) ? process.env.VUE_APP_PORTAL_URL : ''

            if (!this.patient) return ''

            const code = this.patient.patient_code || ''

            return `${base.replace(/\/$/, '')}/resultados?codigo=${encodeURIComponent(code)}`
        }
    },
    methods: {
        ParseCPF(value) {
            if (value) {
                let cpf = ''

                cpf = value.replace(/[^\d]/g, '')

                return cpf.replace(
                    /(\d{3})(\d{3})(\d{3})(\d{2})/,
                    '$1.$2.$3-$4'
                )
            }

            return ''
        },
    },
    mounted() {
        const patient_id = this.$route.query.patient_id

        let account_id = this.$route.query.account_id

        if (!patient_id) return

		window.addEventListener('afterprint', () => {
			if (window.mainWindow){
				window.mainWindow.postMessage({print: true})
			}

			window.close()
		})

        window.api.call('post', '/get-patient', {
            patient_id,
            account_id
        }).then(({ data }) => {
            if(data && data.response) {
                this.patient = data.patient
                this.visibility = 'visible'

                if(!account_id && data.patient && data.patient.account_id) {
                    account_id = data.patient.account_id
                }
            }
        })
        .finally(() => {
            setTimeout(() => window.print(), 800)
        })

        const style_print = window.jQuery('<link>', {
            rel: 'stylesheet',
            type: 'text/css',
            href: require('@/assets/sass/portrait.scss')
        });
        
        style_print.appendTo('head');
    }
}
</script>

<style lang="css" scoped>
	.row {
		gap: 0px 20px;
	}

	.unknown {
		opacity: .5;
	}

	.spotlight {
		font-size: 1.75rem;
	}

	.logo-instant-container {
		position: absolute;
		top: 68px;
		width: 100%;
	}
	
	.header-container {
		height: 161px;
	}

	.main-content {
		position: absolute;
		top: 95px;
	}

	table {
		page-break-after: auto;
	}

	table thead {
		display: table-header-group;
	}

	table tfoot  {
		display: table-footer-group;
	}

	@media print {
		body {
			width: 21cm;
			height: 29.7cm;
			margin: 0 !important;
			padding: 0 !important;
			overflow: hidden;
			background-color: red;
		}

		html, body {
			height:100vh; 
			margin: 0 !important; 
			padding: 0 !important;
			overflow: hidden;
		}

		@page  {
			margin: 2mm 4mm 10mm 4mm;
		}

		footer {
			padding: 0 35px;
			position: fixed;
			right: 0;
			left: 0;
			bottom: 0;
		}
	}
</style>